// @flow
import React, { Fragment, type Node } from 'react';

import { ICONS } from 'Components/utils/icon/icons';
import ratioUtils from 'Components/utils/ratios/ratios.utils';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { ImagePlaceholder } from 'Components/frameworks/image-placeholder/ImagePlaceholder.jsx';

import { themes } from './AdditionItemIcon.themes';

type AdditionItemIconProps = {
  alt?: string,
  iconName: IconName,
  label?: string,
  ratioKey?: MediaRatios,
  symbol?: Node,
  theme?: string,
};

export function AdditionItemIcon(props: AdditionItemIconProps) {
  const { alt, iconName, label, symbol, ratioKey = ratioUtils.XL, theme = 'default' } = props;

  if (!iconName) return null;

  const { thItemIcon, thItemIconSize, thItemLabel, thItemLabelIcon } = themes[theme];

  return (
    <Fragment>
      <ImagePlaceholder aspectRatio={100 * ratioUtils.values[ratioKey]}>
        <div className={thItemIcon}>
          <Icon name={iconName} isNotSquare width={thItemIconSize} />
        </div>
        {symbol}
      </ImagePlaceholder>
      {alt && <span className="a11y">{alt} </span>}
      {!!label && (
        <div className={thItemLabel} data-testid="AdditionItemIcon-label">
          {label}
          <Icon className={thItemLabelIcon} hasRtl name={ICONS.BOLDER_ARROW_FORTH} width="1em" />
        </div>
      )}
    </Fragment>
  );
}
